import { useEffect } from "react"

import { withEnvironmentPrefix } from "features/environmentBadge"

const APP_NAME = "Sentrisense"

/**
 * Sets the browser tab title (`document.title`) for the current page.
 *
 * Pass the page-specific title (a translated generic label, or a dynamic
 * entity name such as a device/tower/powerline name). When `title` is falsy
 * (e.g. data is still loading), the tab falls back to the plain app name so it
 * is never stale-wrong.
 */
const useDocumentTitle = (title?: string | null | false) => {
  useEffect(() => {
    document.title = withEnvironmentPrefix(title ? `${title} | ${APP_NAME}` : APP_NAME)
  }, [title])
}

export default useDocumentTitle
